<div *ngIf="!isSolutionSelected" class="flex flex-col ml-72 pb-20">
  <div class="flex flex-row justify-between top-header">
    <div class="flex items-center">
      <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-20 mr-20"
          [routerLink]="['/', authService.principal.provider, RouterSegments.TENANT, tenantId, RouterSegments.CUSTOM_IMAGE]"></mat-icon>
      <h2 class="mat-headline-5 mt-20 mb-0">{{'CREATE_SERVICE.CHOOOSE_SOLUTION' | transloco}}</h2>
    </div>
    <div class="flex flex-row justify-center items-center mt-20">
      <div class="flex flex-row justify-between items-center search-wrapper">
        <app-search-filter (keyup)="searchSolution($event)" [placeholder]="'SOLUTIONS.SEARCH_SOLUTION'"></app-search-filter>
      </div>
      <div>
        <button class="flex justify-center items-center context-menu-icon pl-16 pr-16" (click)="filterColumns()">
          <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
          <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
        </button>
      </div>
      <div class="flex flex-row">
        <mat-icon class="mr-8 cursor-pointer view-option" [ngClass]="{'selected-icon': viewSelected==='grid'}" svgIcon="grid_view" (click)="viewSelected='grid'"></mat-icon>
        <mat-icon class="mr-8 cursor-pointer view-option" [ngClass]="{'selected-icon': viewSelected==='list'}" svgIcon="format_list_bulleted" (click)="viewSelected='list'"></mat-icon>
      </div>
    </div>
  </div>
  
  <div class="flex flex-row flex-wrap justify-start items-center pt-10 pl-24 pr-24 pb-10">
    <ng-container *ngIf="selectedLineOfBusiness">
      <span>{{ 'INSTANCE_STATUS.lineOfBusiness' | transloco }}: </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{selectedLineOfBusiness}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm cursor-pointer" (click)="closeMenu(selectedLineOfBusiness)"></mat-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="selectedCategory">
      <span>{{ 'INSTANCE_STATUS.category' | transloco }}: </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{selectedCategory}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm cursor-pointer" (click)="closeMenu(selectedCategory)"></mat-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="selectedRegion">
      <span>{{ 'INSTANCE_STATUS.region' | transloco | titlecase }}: </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{selectedRegion}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm cursor-pointer" (click)="closeMenu(selectedRegion)"></mat-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="selectedTenant">
      <span>{{ 'INSTANCE_STATUS.tenant' | transloco | titlecase }}: </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{selectedTenant}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm cursor-pointer" (click)="closeMenu(selectedTenant)"></mat-icon>
      </span>
    </ng-container>
    <span *ngIf="selectedLineOfBusiness || selectedCategory || selectedRegion || selectedTenant" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"
      (click)="resetFilter()">
      {{ 'BUTTONS.CLEAR_ALL' | transloco }}
    </span>
  </div>
  
  <div *ngIf="!showSpinner && !isFailed && viewSelected==='grid'" class="flex flex-row solutions-container pl-8 pr-8">
    <ng-container *ngFor="let solution of solutionsPage">
      <div class="solution-tile p-12 mr-24 mb-24">
        <div class="flex flex-row justify-between">
          <div class="mat-headline-5 solution-names" [title]="solution.name">{{solution.name}}</div>
        </div>
        <div class="tag-line fs-15">{{solution?.tagline}}</div>
        <div class="fs-14 pt-12"><span class="fw-600">{{'SOLUTIONS.CREATED_ON' | transloco }}: </span>
          <span class="metrics">{{dateTimeFormatService.getUtcFromat(solution?.dateCreated)}}</span></div>
        <div class="flex flex-row items-center pt-12">
          <div class="flex flex-row justify-center items-center pr-8 divider-line">
            <div class="flex flex-row justify-center items-center done-status mr-8">
              <mat-icon svgIcon="done" class="icon-sm"></mat-icon>
            </div>
            <span class="fs-14 metrics">{{solution?.status | titlecase}}</span>
          </div>
          <div class="flex flex-row justify-center items-center pl-8" [ngClass]="{'divider-line pr-8': solution?.tenantId}">
            <mat-icon svgIcon="cloud" class="icon-md mr-8 metrics"></mat-icon>
            <span class="fs-14 metrics">{{solution?.category}}</span>
          </div>
          <div class="flex flex-row justify-center items-center pl-8">
            <span class="fs-14 metrics tenant-name" [title]="solution?.tenantId">{{solution?.tenantId | titlecase}}</span>
          </div>
        </div>
        <mat-divider class="mb-16 mt-16 neutral-2"></mat-divider>
        <div class="flex flex-row justify-end">
          <div class="mat-subtitle-2 fs-14 pl-14 pr-14 pb-4 pt-4 cursor-pointer view-versions"
            (click)="createCustomPackage(solution)">
            {{'CUSTOM_IMAGES.CREATE_CUSTOM_IMAGE' | transloco }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  
  <div *ngIf="!showSpinner && !isFailed && viewSelected==='list'" class="flex flex-row solutions-container pt-16">
    <ng-container *ngFor="let solution of solutionsPage">
      <div class="flex flex-row justify-between items-center w-100-percent solution-grid p-24 mb-8 ml-24 mr-24">
        <div class="flex flex-row justify-start items-center mat-headline-6 m-0 solution-name"><div class="solution-icon mr-16"></div>{{solution.name}}</div>
        <div class="category">
          <div class="flex flex-row justify-start items-center pl-8 pr-8 pt-4 pb-4 category-text">
            <mat-icon svgIcon="cloud" class="icon-md mr-8"></mat-icon>
            {{solution?.category}}
          </div>
        </div>
        <div class="created-on"><span class="fw-700">{{'SOLUTIONS.CREATED_ON' | transloco }}: </span>
          {{dateTimeFormatService.getUtcFromat(solution?.dateCreated)}}</div>
        <div class="flex flex-row justify-start items-center pr-8 status">
          <div class="flex flex-row justify-center items-center done-status mr-8"><mat-icon svgIcon="done" class="icon-sm"></mat-icon></div>
          {{solution?.status}}
        </div>
        <div class="mat-subtitle-2 m-0 cursor-pointer view-versions pt-4 pb-4 pl-10 pr-10" (click)="createCustomPackage(solution)">
          {{'CUSTOM_IMAGES.CREATE_CUSTOM_IMAGE' | transloco }}
        </div>
      </div>
    </ng-container>
  </div>
  
  <mat-card *ngIf="showSpinner" class="flex spinner-container spinner m-24">
    <mat-spinner diameter="24"
      color="primary"
      mode="indeterminate">
    </mat-spinner>
  </mat-card>
  <div *ngIf="solutions?.length === 0 && !showSpinner && !isFailed" class="no-data flex justify-center w-100-percent mt-100 fs-20">
    <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10 mt-6 fw-600"> {{'SOLUTIONS.NO_SOLUTIONS_MESSAGE' | transloco }}</div>
  </div>

  <div *ngIf="isFailed" class="flex justify-center top-panel m-24 p-50">
    {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
  </div>
  <div *ngIf="!showSpinner && !isFailed && solutions?.length > 0" class="top-panel ml-10 mr-24 mt-10 p-20">
    <app-paginator [length]="solutions?.length" [pageSizeOptions]="[10, 15, 20]"
      [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
  </div>
</div>

<div *ngIf="isSolutionSelected" class="flex flex-col pb-20">
  <app-breadcrumb class="mt-16 ml-72 mr-72" [items]="breadcrumbItems" (navigateItem)="navigateItem($event)">
  </app-breadcrumb>
  
  <div class="flex flex-row justify-between mt--16 header">
    <div class="flex flex-row flex-auto pl-72 pt-20 pr-72 pb-16">
      <div class="flex flex-row pt-6">
        <mat-icon svgIcon="arrow_back" class="icon cursor-pointer mt-0"
          (click)="navigateItem({label: 'Solutions'})"></mat-icon>
      </div>
      <div class="flex flex-col flex-auto justify-between pl-24">
        <div class="flex flex-row justify-between mb-14">
          <div class="mat-subtitle-1 fw-600 fs-24 mb-0">{{'CUSTOM_IMAGES.CREATE_CUSTOM_IMAGE' | transloco }}</div>
        </div>
        <div class="flex flex-row items-center mt--4">
          <div class="mat-body fs-14 fw-600 flex items-center">{{'CUSTOM_IMAGES.SOLUTION' | transloco }}:</div>
          <div *ngIf="selectedSolution?.name" class="mat-body fs-14 fw-400 flex items-center ml-6">{{selectedSolution?.name}}</div>
        </div>
      </div>
    </div>
  </div>


  <div class="flex flex-col pl-72 pt-20 pr-72 pb-24">
    <div class="flex flex-row justify-start items-center mb-6">
      <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'CUSTOM_IMAGES.CUSTOM_IMAGE_NAME' | transloco | uppercase }}</label>
      <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'CUSTOM_IMAGES.CUSTOM_IMAGE_NAME' | transloco"
        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
    </div>
    <div class="flex flex-row">
      <div class="flex flex-col">
        <input [formControl]="customImageForm.get('customImageName')" (keyup)="onCustomImageName($event)" class="name-container fw-400 h-34" placeholder="{{'CUSTOM_IMAGES.CUSTOM_IMAGE_NAME' | transloco}}"        type="text" value="{{customImageName}}">
        <app-error [control]="customImageForm.get('customImageName')"></app-error>
      </div>
   
      @if (selectedTab === 0 && !resetJSONEditor) {
      @if (validJson) {
        <div class="flex flex-row justify-center items-center w-50-percent ml-100">
          <div class="valid json-status fw-500">
            <mat-icon svgIcon ="done"></mat-icon>
            {{'CUSTOM_IMAGES.VALID_JSON_FORMAT' | transloco}}
          </div>
        </div>
      } @else if (validJson === false) {
        <div class="flex flex-row justify-center items-center w-50-percent ml-100">
          <div class="invalid json-status fw-500">
            <mat-icon svgIcon ="warning_amber"></mat-icon>
              {{'CUSTOM_IMAGES.INVALID_JSON_FORMAT' | transloco}}
          </div>
        </div>
      }}
    </div>
  </div>

  <div class="ml-72 mr-72 json-form mb-10">
    <div class="flex flex-row tabs items-center">
      <div *ngIf="!isLoading" class="cursor-pointer section-label fw-500 p-10" (click)="tabChange(0)" [ngClass]="{'selected-tab fw-600': selectedTab === 0}">{{'CUSTOM_IMAGES.JSON' | transloco}}</div>
      <div class="vertical-indicator"></div>
      <div *ngIf="!isLoading" class="cursor-pointer section-label fw-500 p-10" (click)="tabChange(1)" [ngClass]="{'selected-tab fw-600': selectedTab === 1}">{{'CUSTOM_IMAGES.FORM' | transloco}}</div>
      <div *ngIf="selectedTab === 0" class="flex justify-end w-100-percent mr-24">
        <button class="flex flex-row fw-500 items-center mr-16 clear" (click)="clearJson()">
          <mat-icon svgIcon="close" class="icon-sm"></mat-icon>
          <span>{{'BUTTONS.CLEAR' | transloco}}</span>
        </button>
        <button class="flex flex-row fw-500 items-center paste" (click)="pasteJson()">
          <mat-icon svgIcon="content_paste" class="icon-sm"></mat-icon>
          <span>{{'BUTTONS.PASTE' | transloco}}</span>
        </button>
      </div>
      <div *ngIf="selectedTab === 1 && formData?.length > 0" class="flex justify-end items-center w-100-percent mr-16">
        <ng-container *ngIf="componentsLoading && formData?.length > 0">
          <mat-spinner diameter="20" color="progress-color" mode="indeterminate"></mat-spinner>
          <span class="mat-body-2 fw-500 fs-12 ml-12 mr-12">{{'CUSTOM_IMAGES.LOADING_COMPONENTS' | transloco}}</span>
        </ng-container>
        <ng-container *ngIf="!componentsLoading && components?.length > 0 && formData?.length > 0">
          <img src="/assets/icons/components-loaded.svg" class="icon-md mr-4">
          <span class="mat-body-2 fw-500 fs-12 mr-12">{{'CUSTOM_IMAGES.COMPONENTS_LOADED' | transloco}}</span>
        </ng-container>
        <ng-container *ngIf="!componentsLoading && components === null && formData?.length > 0">
          <mat-icon svgIcon="warning_amber" class="icon-md mr-4 warn-solid-fg"></mat-icon>
          <span class="mat-body-2 fw-500 fs-12 mr-12">{{'ACTIVITY_DETAILS.NO_COMPONENTS' | transloco}}</span>
        </ng-container>
        <button type="button" [disabled]="componentsLoading || !components" [ngClass]="{'disabled': componentsLoading || !components}" class="flex accent justify-center items-center mat-subtitle-2" mat-button
          (click)="addComponent()">
          <mat-icon svgIcon="add" class="icon-md-2"></mat-icon>
          {{'CUSTOM_IMAGES.ADD_COMPONENT' | transloco }}
        </button>
      </div>
    </div>

    <div *ngIf="selectedTab === 0">
      <div>
        <ngx-monaco-editor
          [options]="editorOptions"
          [(ngModel)]="jsonInput"
          class="editor"
        >
      </ngx-monaco-editor>
      </div>
    </div>
    <div *ngIf="selectedTab === 1">
      <div *ngIf="componentsLoading && formData?.length === 0" class="loading-components">
        <mat-spinner diameter="48" color="progress-color" mode="indeterminate"></mat-spinner>
        <div class="loading-title fw-500 fs-14">
          {{'CUSTOM_IMAGES.LOADING_COMPONENTS' | transloco}}
        </div>
        <div class="loading-message fw-400 fs-12">
          {{'CUSTOM_IMAGES.LOADING_COMPONENTS_MESSAGE' | transloco}}
        </div>
      </div>
      <div *ngIf="!componentsLoading && components === null && formData?.length === 0" class="flex flex-col items-center justify-center mt-150">
        <mat-icon svgIcon="warning_amber" class="icon-xl warn-solid-fg"></mat-icon>
        <div class="loading-title fw-500 fs-14">
          {{'ACTIVITY_DETAILS.NO_COMPONENTS' | transloco}}
        </div>
        <button type="button" [disabled]="!components" [ngClass]="{'disabled': !components}" class="flex accent justify-center items-center mat-subtitle-2 mt-12" mat-button
          (click)="addComponent()">
          <mat-icon svgIcon="add" class="icon-md-2"></mat-icon>
          {{'CUSTOM_IMAGES.ADD_COMPONENT' | transloco }}
        </button>
      </div>
      <div *ngIf="!componentsLoading && components && formData?.length === 0" class="flex flex-col items-center justify-center mt-150">
        <img class="flex justify-center items-center" src="/assets/icons/components-loaded.svg">
        <div class="loading-title fw-500 fs-14">
          {{'CUSTOM_IMAGES.COMPONENTS_LOADED' | transloco}}
        </div>
        <button type="button" [disabled]="!components" [ngClass]="{'disabled': !components}" class="flex accent justify-center items-center mat-subtitle-2 mt-12" mat-button
          (click)="addComponent()">
          <mat-icon svgIcon="add" class="icon-md-2"></mat-icon>
          {{'CUSTOM_IMAGES.ADD_COMPONENT' | transloco }}
        </button>
      </div>
      <div *ngFor="let data of formData; let last = last">
        <div class="mt-16 mb-16 ml-16 mr-16 flex flex-row justify-between items-center">
          <div class="flex items-center">
            <span class="comp-name mat-body-1 fw-600">{{'CUSTOM_IMAGES.COMPONENT_NAME' | transloco }}:</span><span class="ml-6 mat-body-1 fw-600 ellipsis" [matTooltip]="data?.component ? data?.component : ''"
              matTooltipPosition="above" matTooltipClass="mat-tooltip tooltip-inner data-tooltip above pt-8 pr-8 pb-8 pl-8 fs-16">{{data?.component}}</span>
          </div>
          <div class="flex flex-row items-center">
            <button (click)="editClick(data)" class="flex justify-center items-center h-32 edit pl-8 pr-8 pb-4 pt-4">
              <div class="flex flex-row justify-start items-center">
                <mat-icon svgIcon="edit" class="icon-md mr-4"></mat-icon>
                <div class="mat-body-1 mb-0 fw-500 fs-16">{{'BUTTONS.EDIT' | transloco }}</div>
              </div>
            </button>
            <button (click)="deleteClick(data)" class="flex justify-center items-center h-32 delete-btn ml-16 pl-8 pr-8 pb-4 pt-4">
              <div class="flex flex-row justify-start items-center">
                <mat-icon svgIcon="delete" class="icon-md mr-4 delete"></mat-icon>
                <div class="mat-body-1 mb-0 fw-500 fs-16 delete">{{'BUTTONS.DELETE' | transloco }}</div>
              </div>
            </button>
          </div>
        </div>
        <div class="flex flex-row form-data ml-16" [ngClass]="{'mb-16': last}">
          <div class="image-pack p-16 mr-24">
            <div class="mat-body-1 fw-600">{{'CUSTOM_IMAGES.IMAGES' | transloco }}</div>
            <div class="flex flex-row header mt-18">
              <div class="mat-subtitle-2 fw-700 fs-12 header-label pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.NAME' | transloco | uppercase }}</div>
              <div class="mat-subtitle-2 fw-700 fs-12 header-label pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.PATH' | transloco | uppercase }}</div>
              <div class="mat-subtitle-2 fw-700 fs-12 header-label pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.TAG' | transloco | uppercase }}</div>
            </div>
            <div *ngIf="!data?.images || data?.images?.length === 0">
              <div class="no-data flex items-center justify-center">{{'CUSTOM_IMAGES.NO_DATA_AVAILABLE' | transloco }}</div>
            </div>
            <ng-container *ngFor="let occurrence of data?.images; let innerLast = last">
              <div class="flex flex-row image">
                <div class="mat-body-1 fs-16 fw-500 header-label pl-16 pt-12 pb-12" [title]="occurrence?.name">{{occurrence?.name}}</div>
                <div class="mat-body-1 fs-16 fw-500 header-label pl-16 pt-12 pb-12" [title]="occurrence?.path">{{occurrence?.path}}</div>
                <div class="mat-body-1 fs-16 fw-500 header-label pl-16 pt-12 pb-12" [title]="occurrence?.version">{{occurrence?.version}}</div>
              </div>
              <mat-divider *ngIf="!innerLast" class="neutral-2 ml-8 mr-8"></mat-divider>
            </ng-container>
          </div>

          <div class="image-pack p-16">
            <div class="mat-body-1 fw-600">{{'CUSTOM_IMAGES.PACKAGES' | transloco }}</div>
            <div class="flex flex-row header mt-18">
              <div class="mat-subtitle-2 fw-700 fs-12 header-label pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.NAME' | transloco | uppercase }}</div>
              <div class="mat-subtitle-2 fw-700 fs-12 header-label pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.PATH' | transloco | uppercase }}</div>
              <div class="mat-subtitle-2 fw-700 fs-12 header-label pl-16 pt-12 pb-12">{{'CUSTOM_IMAGES.TAG' | transloco | uppercase }}</div>
            </div>
            <div *ngIf="!data?.packages || data?.packages?.length === 0">
              <div class="no-data flex items-center justify-center">{{'CUSTOM_IMAGES.NO_DATA_AVAILABLE' | transloco }}</div>
            </div>
            <ng-container *ngFor="let occurrence of data?.packages; let innerLast = last">
              <div class="flex flex-row image">
                <div class="mat-body-1 fs-16 fw-500 header-label pl-16 pt-12 pb-12" [title]="occurrence?.name">{{occurrence?.name}}</div>
                <div class="mat-body-1 fs-16 fw-500 header-label pl-16 pt-12 pb-12" [title]="occurrence?.path">{{occurrence?.path}}</div>
                <div class="mat-body-1 fs-16 fw-500 header-label pl-16 pt-12 pb-12" [title]="occurrence?.version">{{occurrence?.version}}</div>
              </div>
              <mat-divider *ngIf="!innerLast" class="neutral-2 ml-8 mr-8"></mat-divider>
            </ng-container>
          </div>
        </div>
        <mat-divider *ngIf="!last" class="neutral-2 ml-16 mr-16 mt-16"></mat-divider>
      </div>
    </div>
  </div>
  <mat-divider class="neutral-2 ml-72 mr-72 mt-16 mb-16"></mat-divider>
  <div class="footer ml-72 mr-72 mb-16">
    <div class="flex flex-row justify-end">
      <button class="flex justify-items-center items-center cancel-btn mr-16 pr-16 pl-16 pt-8 pb-8" type="button" (click)="navigateItem({label: 'Solutions'})">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button *ngIf="selectedTab === 0" class="accent" (click)="validateJson()">{{'BUTTONS.VALIDATE' | transloco}}</button>
      <button *ngIf="selectedTab === 0 && validJson && !resetJSONEditor" class="accent ml-16" (click)="nextClick()" type="button">{{'BUTTONS.NEXT' | transloco}}</button>
      <button *ngIf="selectedTab === 1" class="accent" (click)="(formData?.length === 0 || customImageForm.get('customImageName')?.hasError('duplicateName')) ? '' : submitClick()" [ngClass]="{'disabled': (formData?.length === 0 || customImageForm.get('customImageName')?.hasError('duplicateName'))}" type="button">{{'BUTTONS.SUBMIT' | transloco}}</button>
    </div>
  </div>
</div>